<template>
    <div class="animated fadeIn">
        <div>
            <b-row v-if="loading">
                <b-col cols="12" md="6">
                    <atom-spinner
                        :animation-duration="1000"
                        :size="60"
                        color="#ff1d5e"
                        class="float-right my-4"
                    />
                </b-col>
            </b-row>
        </div>
        <div v-if="!loading" class="mt-1">
            <b-row class="align-items-center mb-3">
                <b-col cols="12" sm="7" md="9">
                    <h3 class="mb-0">Daily Report</h3>
                </b-col>

                <b-col
                    cols="12"
                    sm="5"
                    md="3"
                    class="d-flex justify-content-end justify-content-sm-end justify-content-md-end pl-3 pl-sm-3 pl-md-0 mt-2 mt-sm-0"
                >
                    <b-button
                        variant="primary"
                        @click="
                            $router.push({
                                path: '/analytics/history/CUSTOMER',
                            })
                        "
                    >
                        View Download History
                    </b-button>
                </b-col>
            </b-row>

            <b-row class="mt-3 align-items-center">
                <b-col cols="10" sm="11" md="8" class="mb-2 mb-sm-0">
                    <h4>Daily Registration Report</h4>
                </b-col>

                <b-col
                    cols="2"
                    sm="1"
                    md="1"
                    class="mb-2 mb-sm-2 pr-1 pr-md-0 ml-n1 ml-md-0 d-flex justify-content-sm-start justify-content-start justify-content-md-end"
                >
                    <img
                        src="@/assets/images/DataExport.png"
                        class="upload-btn"
                        alt="data export"
                        @click="createRequest"
                    />
                </b-col>

                <b-col cols="12" sm="12" md="3" class="pl-1 pl-md-0">
                    <eb-select
                        ref="dateRef"
                        class="select-background-white"
                        id="text"
                        type="text"
                        label="text"
                        :options="dateOption"
                        v-model="selectedDate"
                        :selected="selectedDate.text"
                        @input="changeDate"
                    >
                    </eb-select>

                    <c-date
                        ref="compRefs"
                        modalRef="modalRef"
                        modalId="dateModal"
                        @customDateRange="findDateResult"
                    ></c-date>
                </b-col>
            </b-row>

            <div
                v-if="
                    $currentUserData.category == 'Admin' ||
                    $currentUserData.category == 'TA' ||
                    $currentUserData.category == 'DISTRIBUTOR' ||
                    $currentUserData.category == 'DEALER' ||
                    $currentUserData.category == 'SELLER' ||
                    $userRole == 'Tenant' ||
                    $userRole == 'Admin'
                "
            >
                <div class="chart-container">
                    <BarChart
                        value="daily-registration"
                        :chart-data="chartData"
                    />
                </div>
            </div>

            <div v-else>
                <h4 class="text-center my-5">No Data Available</h4>
            </div>
        </div>
    </div>
</template>
<script>
import ebSelect from "@/components/FormElements/Select.vue";
import BarChart from "@/components/chart/BarChart";
import moment from "moment";
import dailyRegistrationChartData from "@/utils/dailyRegistrationChartData";
import cDate from "@/components/FormElements/CustomDate.vue";
import { AtomSpinner } from "epic-spinners";
export default {
    name: "Reports",
    components: {
        BarChart,
        ebSelect,
        cDate,
        AtomSpinner,
    },
    data() {
        return {
            prevSelectedDate: null,
            loading: false,
            chartOptions: {
                hoverBorderWidth: 10,
            },
            selectedDate: {
                text: "Today",
                value: 1,
            },
            dateOption: [
                {
                    text: "Today",
                    value: 1,
                },
                {
                    text: "7 day's",
                    value: 7,
                },
                {
                    text: "30 day's",
                    value: 30,
                },
                {
                    text: "Custom",
                    value: "custom",
                },
            ],
            startDate: "",
            endDate: "",
        };
    },
    computed: {
        userId() {
            if (this.$store.getters["auth/getUserID"]) {
                return this.$store.getters["auth/getUserID"];
            } else {
                return JSON.parse(sessionStorage.getItem("userLogin"))["_id"];
            }
        },
        chartData() {
            let data = this.$store.getters["partner/GetBulkAnalyticsRept"];
            let dailyRegistrationKey = "";
            let registrationCount = "";
            let dayCount = "";
            if (this.$currentUserData.role == "Admin") {
                dailyRegistrationKey = "admin-daily-registration-graph";
                registrationCount = "count";
                dayCount = "day";
            } else if (this.$currentUserData.category == "TA") {
                dailyRegistrationKey = "daily-registration-graph";
                registrationCount = "count";
                dayCount = "day";
            } else if (this.$currentUserData.category === "SELLER") {
                dailyRegistrationKey = "seller-daily-registration-graph";
                registrationCount = "count";
                dayCount = "day";
            } else if (
                this.$currentUserData.category === "DISTRIBUTOR" ||
                this.$currentUserData.category === "DEALER" ||
                this.$currentUserData.category === "SUB_DEALER"
            ) {
                dailyRegistrationKey = "subdealer-daily-registration-graph";
                registrationCount = "count";
                dayCount = "day";
            }
            const dailyRegistration = data[dailyRegistrationKey];
            return dailyRegistrationChartData(
                dailyRegistration,
                registrationCount,
                dayCount,
            );
        },
    },
    methods: {
        findDateResult(e) {
            this.startDate = e.fromDate;
            this.endDate = e.toDate;
            this.selectedDate = { text: "Custom", value: "custom" };
            this.getAnalyticsData().then(() => {
                this.$nextTick(() => {
                    if (this.$refs["dateRef"] && this.$refs["dateRef"].close) {
                        this.$refs["dateRef"].close();
                    } else if (
                        this.$refs["dateRef"] &&
                        this.$refs["dateRef"].$el
                    ) {
                        const el =
                            this.$refs["dateRef"].$el.querySelector("input") ||
                            this.$refs["dateRef"].$el;
                        if (el && el.blur) el.blur();
                    }
                });
            });
        },
        changeDate(e) {
            if (e.value === "custom") {
                this.prevSelectedDate = { ...this.selectedDate };
                this.selectedDate = this.prevSelectedDate;
                this.$nextTick(() => {
                    if (this.$refs["dateRef"] && this.$refs["dateRef"].close) {
                        this.$refs["dateRef"].close();
                    } else if (
                        this.$refs["dateRef"] &&
                        this.$refs["dateRef"].$el
                    ) {
                        const el =
                            this.$refs["dateRef"].$el.querySelector("input") ||
                            this.$refs["dateRef"].$el;
                        if (el && el.blur) el.blur();
                    }
                    this.$refs["compRefs"].openModal();
                });
            } else {
                this.selectedDate = e;
                this.getAnalyticsData();
            }
        },
        getApiKeyPrefix() {
            if (this.$currentUserData?.role === "Admin") {
                return "admin-";
            } else if (this.$currentUserData?.category === "SELLER") {
                return "seller-";
            } else if (
                this.$currentUserData?.category === "DISTRIBUTOR" ||
                this.$currentUserData?.category === "DEALER" ||
                this.$currentUserData?.category === "SUB_DEALER"
            ) {
                return "subdealer-";
            }
            return ""; // TA category
        },
        getApiVariables(additionalVars = {}) {
            const baseVars = { ...additionalVars };
            if (this.$currentUserData?.role === "Admin") {
                return baseVars;
            } else if (this.$currentUserData?.category === "TA") {
                return { ...baseVars, tenant: this.userId };
            } else if (
                this.$currentUserData?.category === "SELLER" ||
                this.$currentUserData?.category === "DISTRIBUTOR" ||
                this.$currentUserData?.category === "DEALER" ||
                this.$currentUserData?.category === "SUB_DEALER"
            ) {
                return {
                    ...baseVars,
                    userId: this.userId,
                    tenant: this.$currentUserData?.tenant,
                };
            }
            return baseVars;
        },
        async getAnalyticsData() {
            const prefix = this.getApiKeyPrefix();
            const dateData = this.getDateData(this.selectedDate.value);
            const variables = this.getApiVariables(dateData);
            const apiKey = `${prefix}daily-registration-graph`;

            const payload = {
                items: [
                    {
                        key: apiKey,
                        variables: variables,
                    },
                ],
            };
            await this.$store.dispatch(
                "partner/fetchBulkAnalyticReport",
                payload,
            );
        },
        getDateData(dateData) {
            if (dateData === "custom") {
                return {
                    fromDate: this.startDate,
                    toDate: this.endDate,
                };
            }
            if (dateData === 1) {
                const today = moment().format("YYYY-MM-DD");
                return {
                    fromDate: today,
                    toDate: today,
                };
            }
            if (typeof dateData === "number") {
                return {
                    fromDate: moment()
                        .subtract(dateData - 1, "days")
                        .format("YYYY-MM-DD"),
                    toDate: moment().format("YYYY-MM-DD"),
                };
            }
            if (typeof dateData === "object") {
                return dateData;
            }
            // Default fallback
            return {
                fromDate: moment().subtract(30, "days").format("YYYY-MM-DD"),
                toDate: moment().format("YYYY-MM-DD"),
            };
        },
        createRequest() {
            const payload = {
                filterBy: {
                    ...this.getDateData(this.selectedDate.value),
                    collectionName: "CUSTOMER",
                },
                requestBy: {
                    _id: this.$currentUserData._id,
                    name: this.$currentUserData.userName,
                    email: this.$currentUserData.email,
                    phone: this.$currentUserData.phone,
                },
            };
            this.$store
                .dispatch("partner/createRequestDownload", payload)
                .then(() => {
                    this.$swal({
                        title: "Success",
                        text: "Request successful!!",
                        type: "success",
                    });
                })
                .catch((error) =>
                    this.$toasted.error(
                        error.message
                            ? error.message
                            : "Error Request could not completed",
                    ),
                );
        },
    },

    mounted() {
        this.getAnalyticsData();
    },
};
</script>
<style scoped>
.upload-btn {
    width: 28px;
    height: 34px;
    object-fit: contain;
    cursor: pointer;
}

.select-background-white {
    background-color: #fff;
}

.chart-container {
    position: relative;
    width: 100%;
    min-height: 400px;
}

@media (max-width: 768px) {
    .chart-container {
        min-height: 300px;
    }
}
</style>
